














import { Component, Prop, Vue } from 'vue-property-decorator'
import { statusMap } from '@/utils/status-map'

@Component
export default class StatusEffective extends Vue {
    statusMap = statusMap
    @Prop() status!: number
}
